import { render, staticRenderFns } from "./special_list.vue?vue&type=template&id=2c77b59a&"
import script from "./special_list.vue?vue&type=script&lang=js&"
export * from "./special_list.vue?vue&type=script&lang=js&"
import style0 from "./special_list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports